/**
 * AUTO-GENERATED third-party licence notices (licensing audit 2026-08-24).
 * Do not hand-edit: regenerate with third_party_notices.generator.mjs and
 * re-emit via emit_js_constant.mjs when dependencies change.
 * The string below is the legal deliverable, verbatim.
 */
export const THIRD_PARTY_NOTICES_MD = `# Third-Party Notices — Duffloo Website (duffloo.com, Gatsby)

This product includes third-party software. Generated 2026-08-24 from the Website-3 dependency manifest (direct production dependencies; 54 packages).

## @fontsource/baloo-2 5.2.7
- License: OFL-1.1
- Copyright 2019 The Baloo 2 Project Authors (https://github.com/EkType/Baloo2)

## @fontsource/inter-tight 5.2.7
- License: OFL-1.1
- Copyright 2022 The Inter Project Authors (https://github.com/rsms/inter-tight) InterTight-Italic[wght].ttf: Copyright 2022 The Inter Project Authors (https://github.com/rsms/inter-tight)

## @fontsource/manrope 5.2.8
- License: OFL-1.1
- Copyright 2019 The Manrope Project Authors (https://github.com/sharanda/manrope)

## @fontsource/nunito 5.2.7
- License: OFL-1.1
- Copyright 2014 The Nunito Project Authors (https://github.com/googlefonts/nunito) Nunito-Italic[wght].ttf: Copyright 2014 The Nunito Project Authors (https://github.com/googlefonts/nunito)

## @fontsource/outfit 5.0.13
- License: OFL-1.1
- Copyright 2021 The Outfit Project Authors (https://github.com/Outfitio/Outfit-Fonts)

## @mdx-js/mdx 3.0.1
- License: MIT
- Copyright (c) 2017 Compositor, Inc. and Vercel, Inc.

## @mdx-js/react 2.3.0
- License: MIT
- Copyright (c) 2017 Compositor and Vercel, Inc.

## @reduxjs/toolkit 2.2.6
- License: MIT
- Copyright (c) 2018 Mark Erikson

## @stripe/react-stripe-js 5.4.1
- License: MIT
- Copyright (c) 2017 Stripe

## @stripe/stripe-js 8.5.3
- License: MIT
- Copyright (c) 2017 Stripe

## axios 1.7.2
- License: MIT
- Copyright (c) 2014-present Matt Zabriskie & Collaborators

## dayjs 1.11.12
- License: MIT
- Copyright (c) 2018-present, iamkun

## embla-carousel-autoplay 8.3.0
- License: MIT
- Copyright the embla-carousel-autoplay contributors

## embla-carousel-class-names 8.3.0
- License: MIT
- Copyright the embla-carousel-class-names contributors

## embla-carousel-react 8.3.0
- License: MIT
- Copyright the embla-carousel-react contributors

## firebase 10.12.4
- License: Apache-2.0
- Copyright the firebase contributors

## formik 2.4.6
- License: Apache-2.0
- Copyright the formik contributors

## framer-motion 11.11.10
- License: MIT
- Copyright (c) 2018 Framer B.V.

## gatsby 5.16.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-plugin-anchor-links 1.2.1
- License: MIT
- Copyright (c) 2015 gatsbyjs

## gatsby-plugin-clarity 1.0.1
- License: MIT
- Copyright the gatsby-plugin-clarity contributors

## gatsby-plugin-csp 1.1.4
- License: MIT
- Copyright (c) 2019 Thom Krupa

## gatsby-plugin-image 3.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-plugin-mailgo 0.12.2
- License: MIT
- Copyright the gatsby-plugin-mailgo contributors

## gatsby-plugin-manifest 5.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-plugin-mdx 5.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-plugin-purgecss 6.2.1
- License: MIT
- Copyright (c) 2018 Ananto Ghosh

## gatsby-plugin-react-svg 3.3.0
- License: MIT
- Copyright (c) 2017 Jacob Mischka

## gatsby-plugin-robots-txt 1.8.0
- License: MIT
- Copyright (c) 2018 Marat Dreizin

## gatsby-plugin-sass 6.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-plugin-sharp 5.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-plugin-sitemap 6.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-remark-copy-linked-files 6.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-remark-images 7.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-remark-prismjs 7.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-source-filesystem 5.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-transformer-remark 6.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## gatsby-transformer-sharp 5.13.1
- License: MIT
- Copyright (c) 2015 Gatsbyjs

## libphonenumber-js 1.12.40
- License: MIT
- Copyright (c) 2016 @catamphetamine <purecatamphetamine@gmail.com>

## phone 3.1.49
- License: MIT
- Copyright (c) 2013-2020 AfterShip

## prismjs 1.30.0
- License: MIT
- Copyright (c) 2012 Lea Verou

## react 18.2.0
- License: MIT
- Copyright (c) Facebook, Inc. and its affiliates.

## react-device-detect 2.2.3
- License: MIT
- Copyright (c) 2017 duskload

## react-dom 18.2.0
- License: MIT
- Copyright (c) Facebook, Inc. and its affiliates.

## react-google-autocomplete 2.7.3
- License: ISC
- Copyright (c) 2016 Ven Korolev

## react-intersection-observer 9.13.1
- License: MIT
- Copyright (c) 2023 React Intersection Observer authors

## react-lite-youtube-embed 2.4.0
- License: MIT
- Copyright (c) 2021 Ibrahim Cesar

## react-modal 3.16.1
- License: MIT
- Copyright (c) 2017 Ryan Florence

## react-redux 9.1.2
- License: MIT
- Copyright (c) 2015-present Dan Abramov

## react-ticker 1.3.2
- License: MIT
- Copyright the react-ticker contributors

## recharts 2.12.7
- License: MIT
- Copyright (c) 2015-present recharts

## sass 1.77.6
- License: MIT
- Copyright (c) 2016, Google Inc.

## signature_pad 5.1.3
- License: MIT
- Copyright (c) 2018 Szymon Nowak

## yup 1.4.0
- License: MIT
- Copyright (c) 2014 Jason Quense
`;
